import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OrangeCircularProgress from '../../../ui/controls/circularProgress';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import CallAccountCard from '../../../ui/cards/callAccountCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

const DailyAccount = ({ accountList, loading }) => {
  const [dailyAccounts, setDailyAccounts] = useState([]);

  useEffect(() => {
    if (accountList) {
      let d_accounts = [];
      for (let i = 0; i < accountList.length; i++) {
        const account = accountList[i];
        d_accounts.push(account._id);
      }
      setDailyAccounts(d_accounts);
    }
  }, [accountList]);

  return loading ? (
    <OrangeCircularProgress caption="Fetching your daily accounts." />
  ) : dailyAccounts.length > 0 ? (
    <Fragment>
      <Box display={'flex'} justifyContent={'start'} alignSelf={'start'}>
        <AccountBalanceIcon />
        <Typography ml={1} mb={1} variant="h5">
          Investec Call Account (Daily)
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mb={3}>
        {dailyAccounts.map((accountId, index) => (
          <CallAccountCard accountId={accountId} key={index} />
        ))}
      </Box>
    </Fragment>
  ) : null;
};

DailyAccount.propTypes = {
  dailyAccountList: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired
};

export default DailyAccount;
